import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import { DynamicDialogComponent } from 'primeng/dynamicdialog';
import {PrimeNG} from "primeng/config";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class AppComponent implements OnInit{

	constructor(private primeConfig: PrimeNG ) { }

	ngOnInit(): void {
		// Enabling ripple effect
		this.primeConfig.ripple.set(true);

		// Primeng locale
		this.primeConfig.setTranslation({
			dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
			dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
			monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
			today: 'Сегодня',
			clear: 'Очистить',
			weekHeader: 'Нд',
			emptySearchMessage: 'Ничего не найдено',
      emptyFilterMessage:'Ничего не найдено',
      emptySelectionMessage: 'Ничего не найдено',
      emptyMessage: 'Ничего не найдено',
		});
	}

}
